// extracted by mini-css-extract-plugin
export default {"backdrop":"AddNewText_backdrop__hnZQz","z_index_100":"AddNewText_z_index_100__dW8qx","modal_title":"AddNewText_modal_title__NekR0","BlogIcon":"AddNewText_BlogIcon__AtBbC"};